import type { DevelopmentArea } from "../patterns.api";

const paths: Record<DevelopmentArea["key"], string[]> = {
  forcing_calculation: ["M16 3 7 18h8l-1 11 11-17h-8Z", "m5 7 4 4m18-4-4 4"],
  tactical_geometry: ["M4 5h8v8H4Zm16 14h8v8h-8Z", "m12 9 8 14M9 13l11 6"],
  piece_safety: ["M16 3 5 7v8c0 7 4 12 11 14 7-2 11-7 11-14V7Z", "m11 16 3 3 7-8"],
  king_safety: ["M5 14 16 4l11 10v14H5Z", "M12 28v-8h8v8m-7-15h6l-1-5 3-2-5-3-5 3 3 2Z"],
};

export const DevelopmentGlyph = ({ area }: { area: DevelopmentArea["key"] }) => (
  <svg
    data-development-glyph={area}
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 32 32"
    width="34"
    height="34"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="miter"
  >
    {paths[area].map((path) => (
      <path key={path} d={path} />
    ))}
  </svg>
);
